import { Component, OnInit, Input } from '@angular/core';
import { MatTable } from '@angular/material';
import { first } from 'rxjs/operators';
import { KeyEventsPlugin } from '@angular/platform-browser/src/dom/events/key_events';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationConstants } from '../../providers/application-constants';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.css']
})
export class KeyboardComponent implements OnInit {

  @Input('showKeyBoard') showKeyBoard: String;

  Decimal_Point_Msg; Unit_Price_Msg;

  constructor(
    public translate: TranslateService, private applicationConstants: ApplicationConstants,) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Decimal_Point_Msg').subscribe((res: string) => {
      this.Decimal_Point_Msg = res;
    });

    translate.get('Unit_Price_Msg').subscribe((res: string) => {
      this.Unit_Price_Msg = res;
    });
    
  }


  ngOnInit() {
  }

  enterNum(event) {
    let enter_num = (document.getElementById('enter_num') as HTMLInputElement).value;
    if(event.srcElement.value == '+') 
      (document.getElementById('btn_addLine') as HTMLButtonElement).click();
    else if(event.srcElement.value == '-')
      (document.getElementById('btn_delLine') as HTMLButtonElement).click();
    else if(event.srcElement.value == '>') {
      if(enter_num != '')
        (document.getElementById('enter_num') as HTMLInputElement).value = enter_num.substring(0, (enter_num.length - 1));
    }
    else if(event.srcElement.value == '.') {
      if(enter_num == '')
        (document.getElementById('enter_num') as HTMLInputElement).value = '0' + event.srcElement.value;
      else if(enter_num.indexOf('.') == -1)
        (document.getElementById('enter_num') as HTMLInputElement).value = enter_num + event.srcElement.value;
      else if(enter_num.indexOf('.') != -1)
        alert(this.Decimal_Point_Msg);
    }
    else 
      (document.getElementById('enter_num') as HTMLInputElement).value = enter_num + event.srcElement.value;
  }

  showInInput(corFiedId) {
    (document.getElementById(corFiedId) as HTMLInputElement).value = (document.getElementById('enter_num') as HTMLInputElement).value;
    (document.getElementById('enter_num') as HTMLInputElement).value = '';
    let event = new MouseEvent('input'); 
    (document.getElementById(corFiedId) as HTMLInputElement).dispatchEvent(event);
  }

  showInSub() {
    // let lastElement = (document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild;
    // let firstElement = ((document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild).firstElementChild;
    let firstInput = (((document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild).firstElementChild).firstElementChild as HTMLInputElement;
    let id = firstInput.id;
    let row_id = id.substring(id.lastIndexOf('_') + 1);
    (document.getElementById('sub_item_no_' + row_id) as HTMLInputElement).value = (document.getElementById('enter_num') as HTMLInputElement).value;
    (document.getElementById('enter_num') as HTMLInputElement).value = '';
  }

  showInPrice() {
    let firstInput = (((document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild).firstElementChild).firstElementChild as HTMLInputElement;
    if(firstInput.disabled)
      alert(this.Unit_Price_Msg);
    else {
      let id = firstInput.id;
      let row_id = Number(id.substring(id.lastIndexOf('_') + 1));
      (document.getElementById('price_' + (row_id - 1)) as HTMLInputElement).value = (document.getElementById('enter_num') as HTMLInputElement).value;
      (document.getElementById('enter_num') as HTMLInputElement).value = '';
      let event = new MouseEvent('input'); 
      (document.getElementById('price_' + (row_id - 1)) as HTMLInputElement).dispatchEvent(event);
    }
  }

  showInReq() {
    let firstInput = (((document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild).firstElementChild).firstElementChild as HTMLInputElement;
    let id = firstInput.id;
    let row_id = Number(id.substring(id.lastIndexOf('_') + 1));
    (document.getElementById('count_' + (row_id - 1)) as HTMLInputElement).value = (document.getElementById('enter_num') as HTMLInputElement).value;
    (document.getElementById('enter_num') as HTMLInputElement).value = '';
    let event = new MouseEvent('input'); 
    (document.getElementById('count_' + (row_id - 1)) as HTMLInputElement).dispatchEvent(event);
    event = new MouseEvent('focusout');
    (document.getElementById('count_' + (row_id - 1)) as HTMLInputElement).dispatchEvent(event);
  }

  showInDiscount() {
    let firstInput = (((document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild).firstElementChild).firstElementChild as HTMLInputElement;
    let id = firstInput.id;
    let row_id = Number(id.substring(id.lastIndexOf('_') + 1));
    (document.getElementById('discount_' + (row_id - 1)) as HTMLInputElement).value = (document.getElementById('enter_num') as HTMLInputElement).value;
    (document.getElementById('enter_num') as HTMLInputElement).value = '';
    let event = new MouseEvent('input'); 
    (document.getElementById('discount_' + (row_id - 1)) as HTMLInputElement).dispatchEvent(event);
  }

  showInPaid() {
    (document.getElementById('paid_amount') as HTMLInputElement).value = (document.getElementById('enter_num') as HTMLInputElement).value;
    (document.getElementById('enter_num') as HTMLInputElement).value = '';
    let event = new MouseEvent('input'); 
    (document.getElementById('paid_amount') as HTMLInputElement).dispatchEvent(event);
  }

  getSubItem() {
    let firstInput = (((document.getElementById('sub_item_table') as HTMLSourceElement).lastElementChild).firstElementChild).firstElementChild as HTMLInputElement;
    let id = firstInput.id;
    let row_id = Number(id.substring(id.lastIndexOf('_') + 1));

    let event = new KeyboardEvent('keydown', {key: "Enter"}); 
    (document.getElementById('sub_item_no_' + row_id) as HTMLInputElement).dispatchEvent(event); 
  }

}
